/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AutosavePalAuthSubmissionRequest
 */
export interface AutosavePalAuthSubmissionRequest {
    /**
     * 
     */
    form_id: string;
    /**
     * The `saved_at` from the last autosave response this client saw, or null if it never saved. Used to detect a concurrent save from another tab/session.
     */
    expected_saved_at?: string | null;
    /**
     * 
     */
    values: { [key: string]: any; };
}

/**
 * Check if a given object implements the AutosavePalAuthSubmissionRequest interface.
 */
export function instanceOfAutosavePalAuthSubmissionRequest(value: object): value is AutosavePalAuthSubmissionRequest {
    if (!('form_id' in value) || value['form_id'] === undefined) return false;
    if (!('values' in value) || value['values'] === undefined) return false;
    return true;
}

export function AutosavePalAuthSubmissionRequestFromJSON(json: any): AutosavePalAuthSubmissionRequest {
    return AutosavePalAuthSubmissionRequestFromJSONTyped(json, false);
}

export function AutosavePalAuthSubmissionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AutosavePalAuthSubmissionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'form_id': json['form_id'],
        'expected_saved_at': json['expected_saved_at'] === undefined ? undefined : json['expected_saved_at'] === null ? null : json['expected_saved_at'],
        'values': json['values'],
    };
}

export function AutosavePalAuthSubmissionRequestToJSON(json: any): AutosavePalAuthSubmissionRequest {
    return AutosavePalAuthSubmissionRequestToJSONTyped(json, false);
}

export function AutosavePalAuthSubmissionRequestToJSONTyped(value?: AutosavePalAuthSubmissionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'form_id': value['form_id'],
        'expected_saved_at': value['expected_saved_at'],
        'values': value['values'],
    };
}

